export const APPLY_LICENSE_ACCOUNTS = ['zjydjc']



//////////////////
// WEBPACK FOOTER
// ./config/app.js
// module id = 8
// module chunks = 3